import { VARIANT } from '@/constants';
import { FormSelect as CommonFormSelect } from '@monorepo/common';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type FormSelectProps<T extends FieldValues> = UseControllerProps<T> & {
  label?: string;
  placeholder?: string;
  items: Array<{ value: string | number; text: string }>;
  required?: boolean;
  outlined?: boolean;
  onChange?: () => void;
  hint?: string;
  disabled?: boolean;
};

function FormSelect<T extends FieldValues>(props: FormSelectProps<T>) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  return <CommonFormSelect {...(props as any)} variant={VARIANT} />;
}

export default FormSelect;
